import { Toaster } from '@ifixit/ui/components/toast';
import { createTrackedRoot } from 'Shared/react-mount-tracker';

// The one Toaster a page's toasts land in: a page that mounts its own draws
// every toast twice, and no header hosts this on a nanosite or in the app.
const container = document.createElement('div');
document.body.append(container);

createTrackedRoot(container).render(
   <Toaster
      position="bottom-right"
      mobileOffset={{ bottom: 'max(16px, env(safe-area-inset-bottom))' }}
   />
);
